export * from "./common";
export * from "./merchant";
export * from "./car";
export * from "./role";
export * from "./report";

export const defaultFilterQuery = { skip: 0 };
